import { render, staticRenderFns } from "./unionpay-checking.vue?vue&type=template&id=27fae826&scoped=true&"
import script from "./unionpay-checking.vue?vue&type=script&lang=js&"
export * from "./unionpay-checking.vue?vue&type=script&lang=js&"
import style0 from "./unionpay-checking.vue?vue&type=style&index=0&id=27fae826&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fae826",
  null
  
)

export default component.exports